import React from "react";

export const months = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre"
];

export const iconCalendar = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.666 3.33464H15.8327V2.5013C15.8327 2.0013 15.4993 1.66797 14.9993 1.66797C14.4993 1.66797 14.166 2.0013 14.166 2.5013V3.33464H10.8327V2.5013C10.8327 2.0013 10.4993 1.66797 9.99935 1.66797C9.49935 1.66797 9.16602 2.0013 9.16602 2.5013V3.33464H5.83268V2.5013C5.83268 2.0013 5.49935 1.66797 4.99935 1.66797C4.49935 1.66797 4.16602 2.0013 4.16602 2.5013V3.33464H3.33268C2.41602 3.33464 1.66602 4.08464 1.66602 5.0013V15.8346C1.66602 16.7513 2.41602 17.5013 3.33268 17.5013H16.666C17.5827 17.5013 18.3327 16.7513 18.3327 15.8346V5.0013C18.3327 4.08464 17.5827 3.33464 16.666 3.33464ZM5.83268 14.168H4.99935C4.49935 14.168 4.16602 13.8346 4.16602 13.3346C4.16602 12.8346 4.49935 12.5013 4.99935 12.5013H5.83268C6.33268 12.5013 6.66602 12.8346 6.66602 13.3346C6.66602 13.8346 6.33268 14.168 5.83268 14.168ZM5.83268 10.0013H4.99935C4.49935 10.0013 4.16602 9.66797 4.16602 9.16797C4.16602 8.66797 4.49935 8.33464 4.99935 8.33464H5.83268C6.33268 8.33464 6.66602 8.66797 6.66602 9.16797C6.66602 9.66797 6.33268 10.0013 5.83268 10.0013ZM10.416 14.168H9.58268C9.08268 14.168 8.74935 13.8346 8.74935 13.3346C8.74935 12.8346 9.08268 12.5013 9.58268 12.5013H10.416C10.916 12.5013 11.2493 12.8346 11.2493 13.3346C11.2493 13.8346 10.916 14.168 10.416 14.168ZM10.416 10.0013H9.58268C9.08268 10.0013 8.74935 9.66797 8.74935 9.16797C8.74935 8.66797 9.08268 8.33464 9.58268 8.33464H10.416C10.916 8.33464 11.2493 8.66797 11.2493 9.16797C11.2493 9.66797 10.916 10.0013 10.416 10.0013ZM14.9993 14.168H14.166C13.666 14.168 13.3327 13.8346 13.3327 13.3346C13.3327 12.8346 13.666 12.5013 14.166 12.5013H14.9993C15.4993 12.5013 15.8327 12.8346 15.8327 13.3346C15.8327 13.8346 15.4993 14.168 14.9993 14.168ZM14.9993 10.0013H14.166C13.666 10.0013 13.3327 9.66797 13.3327 9.16797C13.3327 8.66797 13.666 8.33464 14.166 8.33464H14.9993C15.4993 8.33464 15.8327 8.66797 15.8327 9.16797C15.8327 9.66797 15.4993 10.0013 14.9993 10.0013Z"
      fill="#F93E4B"
    />
  </svg>
);

export const iconArrowLeft = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.7468 12.7613C10.4177 13.0796 9.88996 13.0796 9.56087 12.7613L5.25318 8.5946C4.91561 8.26808 4.91561 7.73192 5.25318 7.4054L9.56087 3.23874C9.88996 2.92042 10.4177 2.92042 10.7468 3.23874C11.0844 3.56526 11.0844 4.10141 10.7468 4.42793L7.05385 8L10.7468 11.5721C11.0844 11.8986 11.0844 12.4347 10.7468 12.7613Z"
      fill="#EF3340"
    />
  </svg>
);

export const iconArrowRight = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.25318 3.23874C5.58227 2.92042 6.11004 2.92042 6.43913 3.23874L10.7468 7.4054C11.0844 7.73192 11.0844 8.26808 10.7468 8.5946L6.43913 12.7613C6.11004 13.0796 5.58227 13.0796 5.25318 12.7613C4.91561 12.4347 4.91561 11.8986 5.25318 11.5721L8.94615 8L5.25318 4.42793C4.91561 4.10141 4.91561 3.56526 5.25318 3.23874Z"
      fill="#EF3340"
    />
  </svg>
);
